export const CALENDAR_SYNC_SETTINGS_MODULE_ID = 'calendar-sync-settings-module';

export const LOAD_CALENDAR_SYNC_SETTINGS_MODULE = () =>
  import('@capital-access/events/calendar-sync/settings').then(m => m.CalendarSyncSettingsModule);
